import type { Common } from '../common.js';
import { type BlockLog, type FindLogParams } from '../models/flow/blockLog.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/block-logs';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FindLogParams): Promise<BlockLog[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }
}
